export const directory={routes:'/assets/coldchain/routes.json',services:'/api/catalog/v2/services',build:'/ops/build-info.json',archive:'/assets/archive/'};